import {
  CONSTRUTOR_CLEAN_UP,
  CONSTRUTOR_CONSULTA_NAO_ENCONTRADA,
  ERROR_CONSTRUTOR_MSG,
  GET_TABELAS_RELATORIOS_INIT,
  GET_TABELAS_RELATORIOS_SUCCESS,
  POST_EXECUTA_CONSULTA_RELATORIO_INIT,
  POST_EXECUTA_CONSULTA_RELATORIO_SUCCESS,
  CREATE_RELATORIO_INIT,
  CREATE_RELATORIO_SUCCESS,
  UPDATE_RELATORIO_INIT,
  UPDATE_RELATORIO_SUCCESS,
  DELETE_RELATORIO_INIT,
  DELETE_RELATORIO_SUCCESS
} from '../actionTypes';

export const obtemTabelasRelatorioInit = (data) => ({
  type: GET_TABELAS_RELATORIOS_INIT,
  payload: data
});

export const obtemTabelasRelatorioSuccess = (data) => ({
  type: GET_TABELAS_RELATORIOS_SUCCESS,
  payload: data
});

export const executaConsultaRelatorioInit = (data) => ({
  type: POST_EXECUTA_CONSULTA_RELATORIO_INIT,
  payload: data
});

export const executaConsultaRelatorioSuccess = (data) => ({
  type: POST_EXECUTA_CONSULTA_RELATORIO_SUCCESS,
  payload: data
});

export const criarRelatorioInit = (data) => ({
  type: CREATE_RELATORIO_INIT,
  payload: data
});

export const criarRelatorioSuccess = (data) => ({
  type: CREATE_RELATORIO_SUCCESS,
  payload: data
});

export const editarRelatorioInit = (data) => ({
  type: UPDATE_RELATORIO_INIT,
  payload: data
});

export const editarRelatorioSuccess = (data) => ({
  type: UPDATE_RELATORIO_SUCCESS,
  payload: data
});

export const excluiRelatorioInit = (data) => ({
  type: DELETE_RELATORIO_INIT,
  payload: data
});

export const excluiRelatorioSuccess = (data) => ({
  type: DELETE_RELATORIO_SUCCESS,
  payload: data
});

export const construtorConsultaNaoEncontrada = (data) => ({
  type: CONSTRUTOR_CONSULTA_NAO_ENCONTRADA,
  payload: data
});

export const construtorErroMsg = (data) => ({
  type: ERROR_CONSTRUTOR_MSG,
  payload: data
});

export const construtorClearMsg = (data) => ({
  type: CONSTRUTOR_CLEAN_UP,
  payload: data
});
